import React, { Fragment, useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { apiwebUrl } from '../../utils';

import noImgaen from "./../../assets/no-imagen.jpg"
import Modal from './Modal'
function Productos(props) {
    const [idproductos, setIdproductos] = useState([])
    const [seleccion, setSeleccion] = useState([]);
    const [cargar, setCargar] = useState(true)
    const id = props.categoriaProducto



    const getApi = (idcategoria) => {
        fetch(apiwebUrl+"productos.php?idcategoria=" + idcategoria)
            .then(response => response.json())
            .then(data => {
                setIdproductos(data)
                setCargar(false)
            })
    }

    const loader = () => {
        return (
            <div className="spinner">
                <div className="double-bounce1"></div>
                <div className="double-bounce2"></div>
            </div>
        )
    }

    const selecionarProducto = (id) => {
        fetch("https://servicios.campus.pe/productos.php?idproducto=" + id)
            .then(response => response.json())
            .then(data => setSeleccion(data[0]))
    }

    const agregarCarrito  = (item) =>{
        item.cantidad =1;
        let carrito =[]
        
        if(localStorage.getItem("carrito")){
            carrito = JSON.parse(localStorage.getItem("carrito"))
            let producto = -1;
            for (let i = 0; i < carrito.length; i++) {
                let items = carrito[i]
                if(items.idproducto === item.idproducto){
                    producto =i;
                    break;
                }
            }

            if(producto === -1){
                carrito.push(item)
                localStorage.setItem("carrito",JSON.stringify(carrito));
                alert("Se añadio un producto")
            }else{
                let icarrito = carrito[producto]
                icarrito.cantidad++
                carrito[producto] = icarrito;
                localStorage.setItem("carrito",JSON.stringify(carrito));
                alert("Se añadio un producto")
            }
           
        }else{
            carrito.push(item)
            localStorage.setItem("carrito",JSON.stringify(carrito));
            alert("Se añadio un producto")
        }
        
    }
    useEffect(() => {
        getApi(id)
    }, [id])

    return (
        <Fragment>

            <ul className="nav nav-tabs" id="myTab" role="tablist">
                <li className="nav-item" role="presentation">
                    <button className="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#home-tab-pane" type="button" role="tab" aria-controls="home-tab-pane" aria-selected="true"><i className="fa-solid fa-list"></i></button>
                </li>

            </ul>
            <div className="tab-content" id="myTabContent">
                <div className="tab-pane fade show active
                d-flex flex-wrap justify-content-between text-capitalize mt-5
                " id="home-tab-pane" role="tabpanel" aria-labelledby="home-tab" tabIndex="0">
                    {
                        cargar ? loader() :idproductos.map(items => (
                            <div className='col-3 bg-light me-1 mb-2 border border-light p-2 w__full position-relative' key={items.idproducto}>
                                <Link to={"/tienda/detalle/" + items.idproducto}>
                                    <img src={
                                        items.imagenchica != null ?
                                            "https://servicios.campus.pe/" + items.imagenchica
                                            : noImgaen} alt={items.nombre} className="img-fluid w__full" />
                                </Link>

                                <p className='fw-bold text-center'>{items.nombre} <i className="fa-solid fa-cart-shopping" title='Agregar carrito' id="btnagregar"
                                onClick={()=>agregarCarrito(items)}
                                ></i></p>

                                <span className={items.preciorebajado === "0" ? "sin__oferta" : "position-absolute badge bg-danger"} style={{ top: 0, right: 0 }}>{
                                    Math.round(1 - parseFloat(items.preciorebajado) / parseFloat(items.precio) * 100)
                                }%</span>

                                <p className='text-center fw-bold d-flex justify-content-between align-items-center'>precio: <span className='fw-normal  badge bg-light me-1 align-items-center'>S/. {

                                    items.preciorebajado === "0" ?
                                        parseFloat(items.precio).toFixed(2) :
                                        parseFloat(items.preciorebajado).toFixed(2)

                                }</span>
                                    <span className='precio__lista badge bg-light text-danger'>
                                        {
                                            items.preciorebajado !== "0" ?
                                                "S/." + parseFloat(items.precio).toFixed(2) : null
                                        }
                                    </span>
                                    <i className="fa-solid fa-eye p-1 bg-dark text-white hover__icon rounded" style={{ cursor: 'pointer' }} data-bs-toggle="modal" data-bs-target="#clickModal" onClick={() => selecionarProducto(items.idproducto)}></i>
                                </p>

                            </div>
                        ))


                    }
                </div>

            </div>
            <Modal
                seleccion={seleccion}
            />
        </Fragment>
    )
}

export default Productos